/* istanbul ignore file */
// libs
import { Routes } from 'react-router-dom';
// components
import LeadContext from 'domain/sales/lead/LeadContext';
import ViewLead from 'domain/sales/lead/Show';
import { CreateLead, UpdateLead } from 'domain/sales/lead/createupdate';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import LeadListPage from 'domain/sales/lead/List';
import TimelinePage from 'domain/sales/lead/Timeline';
import ShowLead from 'domain/sales/lead/shared/ShowLead';
import ConvertLeadPage from 'domain/sales/lead/Convert';
import { ProtectedRouter } from 'infrastructure/routing';
import { Route } from 'framework/routing';
// services
import { READ_TIMELINE } from 'domain/sales/salesService';
import { READ, UPDATE } from 'domain/shared/core/permissions';
import { CREATE_LEAD, READ_LEADS_LIST, CONVERT_LEAD } from 'domain/sales/lead/shared/leadService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { LEADS_PATH } from 'domain/shared/lead';
import { useLeadRoute } from './leadRouting';

const LeadRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    createRoute: createEntityRoute,
    updateRoute,
    convertRoute,
    timelineRoute,
    singleEntityRoute,
  } = useLeadRoute();

  return (
    <ProtectedRouter basePath={LEADS_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_LEADS_LIST}>
              <LeadListPage />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={createEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_LEAD}>
              <CreateLead />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={singleEntityRoute}
          element={
            <LeadContext permissionToCheck={READ}>
              <ViewLead />
            </LeadContext>
          }
        />

        <Route
          path={updateRoute}
          element={
            <LeadContext permissionToCheck={UPDATE}>
              <UpdateLead />
            </LeadContext>
          }
        />
        <Route
          path={timelineRoute}
          element={
            <LeadContext permissionToCheck={READ_TIMELINE}>
              <TimelinePage />
            </LeadContext>
          }
        />
        <Route
          path={convertRoute}
          element={
            <LeadContext permissionToCheck={CONVERT_LEAD}>
              <ShowLead>
                <ConvertLeadPage />
              </ShowLead>
            </LeadContext>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

LeadRouter.getRouterPath = () => '/leads/*';

export default LeadRouter;
